import React, { useCallback, useMemo } from "react";
import male from "../../assets/images/male.svg";
import { useEffect } from "react";


const statusOptions = [
//   { value: 0, label: "Not Verified" },
  { value: 1, label: "Active" },
  { value: 2, label: "Inactive" },
];

const genderOptions = [
  { value: 1, label: "Male" },
  { value: 2, label: "Female" },
  // { value: 3, label: "Unisex" },
];

export default function CategoryFilter({
  openFilter,
  setOpenFilter,
  params,
  setParams,
}) {
  const handleClear = useCallback(() => {
    setParams({
      status: null,
      gender: null,
      search_key: "",
      page: 1,
      type:1
    });
  }, [setParams]);



  const handleChange = useCallback(
    (category, value) => {
      setParams((prevParams) => ({
        ...prevParams,
        [category]: value,
      }));
    },
    [setParams],
  );

  useEffect(() => {
    setParams((prevParams) => ({
      ...prevParams,
      page: 1,  
    }));
  }, [params.status, params.gender, setParams]); 
  

  const renderedGenderOptions = useMemo(
    () =>
      genderOptions.map((option) => (
        <div key={option.value} className="gender-label">
          <input
            type="radio"
            name="gender"
            value={option.value}
            checked={Number(params.gender) === option.value}
            onChange={() => handleChange("gender", option.value)}
            id={`gender${option.value}`}
          />
          <label htmlFor={`gender${option.value}`}>
            <img src={male} alt="" />
            {option.label}
          </label>
        </div>
      )),
    [params.gender, handleChange],
  );

  const renderedStatusOptions = useMemo(
    () =>
      statusOptions.map((option) => (
        <div key={option.value} className="gender-label">
          <input
            type="radio"
            name="status"
            value={option.value}
            checked={Number(params.status) === option.value}
            onChange={() => handleChange("status", option.value)}
            id={`status${option.value}`}
          />
          <label htmlFor={`status${option.value}`}>{option.label}</label>
        </div>
      )),
    [params.status, handleChange],
  );

  return (
    <>
      <div className={openFilter ? "filter-cont show" : "filter-cont"}>
        <div className="d-flex justify-content-between align-items-center filter-sec-cont">
          <h2>Filter</h2>
          <button className="btn clear-icon" onClick={handleClear}>
            All Clear
          </button>
        </div>
        <button className="btn close-icon" onClick={() => setOpenFilter(false)}>
          <i className="fa fa-times"></i>
        </button>
        <div className="filter-sub">
          <h6>Gender</h6>
          <div className="input-wrapper">{renderedGenderOptions}</div>
        </div>
        <div className="filter-sub">
          <h6>Status</h6>
          <div className="input-wrapper">{renderedStatusOptions}</div>
        </div>
      </div>
    </>
  );
}
